import React from "react";
import { observer, inject } from "mobx-react";
import Metrika from "Services/Metrika";
import {
    CLICK_PHONE_FOOTER,
    CLICK_VK,
    CLICK_GOOGLE,
    CLICK_TWITTER,
    CLICK_FACEBOOK,
    CLICK_INSTAGRAM,
} from "Constants/metriks/Yandex";
import { Footer } from "ComponentsUI/Footer";
import { EVENT_CATEGORY_CLICK_BUTTON } from "Constants/metriks/GoogleCategorys";
import { EVENT_CLICK_PHONE_MAIN } from "Constants/metriks/GoogleActions";
import { withPhone } from "HOC/WithPhone";
import { withRouter } from "react-router-dom";
import withDefaultParams from "Services/withDefaultParams";
import { isMobilePage } from "Utils/routeCheck";

@withRouter
@withDefaultParams
@withPhone
@inject("ApplicationModel")
@observer
export default class FooterContainer extends React.Component {
    onClickHandler() {
        Metrika.getInstance().google.sendEvent(
            EVENT_CATEGORY_CLICK_BUTTON,
            EVENT_CLICK_PHONE_MAIN
        );
    }

    onClickSocialHandler(goal) {}

    render() {
        let {
            location: { pathname },
        } = this.props;

        const notUsedUrls = ["sim-karty"];

        let showPhone = true;

        if (isMobilePage(this.props?.match?.path)) {
            if (
                !this.props.siteRegionPhones?.operators?.show_on_site ||
                this.props.siteRegionPhones?.operators?.phone_view === "hide"
            ) {
                showPhone = false;
            }

            if (!this.props.siteRegionPhones?.operators?.phone) {
                showPhone = false;
            }
        } else {
            if (this.props.siteRegionPhones) {
                if (
                    this.props.siteRegionPhones.hasOwnProperty("show_on_site")
                ) {
                    showPhone = this.props.siteRegionPhones.show_on_site;
                }
                if (notUsedUrls.find(url => pathname.includes(url) == true)) {
                    showPhone = false;
                }
            } else {
                showPhone = false;
            }
        }

        let region = this.props.ApplicationModel.currentRegion;
        const text = this.props.ApplicationModel.text;
        let siteName = this.props.ApplicationModel.siteConfig.name;
        let siteConfig = this.props.ApplicationModel.siteConfig;
        let socialUrls = {};
        siteConfig?.social_our_groups?.forEach(item => {
            socialUrls[item.code] = item.url_group;
        });

        return (
            <Footer
                text={text}
                onClickHandler={() => this.onClickHandler()}
                datatest="main_footer"
                onClickSocialHandler={goal => this.onClickSocialHandler(goal)}
                region={region}
                siteName={siteName}
                socialUrls={socialUrls}
                showPhone={showPhone}
                phone404={this.props.phone404}
            />
        );
    }
}
